import React, { useState, useEffect } from "react";

const Spinner = ({ onLoadComplete }) => {
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress < 100) {
          return prevProgress + 1;
        } else {
          clearInterval(interval); // Stop the interval when progress reaches 100
          setLoading(false); // Set loading to false after reaching 100%
          if (onLoadComplete) {
            onLoadComplete(); // Call the callback function to indicate loading is complete
          }
          return prevProgress; // Keep it at 100
        }
      });
    }, 100);

    return () => clearInterval(interval); // Clean up on component unmount
  }, [onLoadComplete]);

  // Circle properties
  const radius = 40; // Radius of the circle
  const strokeWidth = 8; // Width of the stroke
  const normalizedRadius = radius - strokeWidth * 0.5; // Adjusted radius
  const circumference = normalizedRadius * 2 * Math.PI; // Circumference of the circle
  const strokeDashoffset = circumference - (progress / 100) * circumference; // Stroke offset

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      {loading ? (
        <>
          <h3 style={{ fontFamily: "Arial, sans-serif" }}>
            Loading {progress}%
          </h3>
          <svg width={radius * 2} height={radius * 2}>
            <circle
              stroke="#e0e0e0"
              fill="transparent"
              strokeWidth={strokeWidth}
              r={normalizedRadius}
              cx={radius}
              cy={radius}
            />
            <circle
              stroke="#3498db"
              fill="transparent"
              strokeWidth={strokeWidth}
              r={normalizedRadius}
              cx={radius}
              cy={radius}
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              style={{
                transition: "stroke-dashoffset 0.3s ease",
              }}
            />
          </svg>
        </>
      ) : (
        <h3 style={{ fontFamily: "Arial, sans-serif" }}>Data Loaded</h3>
      )}
    </div>
  );
};

export default Spinner;
